module.exports = __webpack_public_path__ + "static/media/App.9187c6fc.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 721
// module chunks = 1